(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vm-bundle"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vm-bundle')){
class VmBundle extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();
    this.form=this.querySelector('form');
    this.form.addEventListener('change',()=>this.update(),{signal:this.controller.signal});
    this.form.addEventListener('submit',event=>this.submit(event),{signal:this.controller.signal});
    this.update();
  }
  disconnectedCallback(){this.controller.abort();}
  rows(){return [...this.querySelectorAll('[data-bundle-row]')].filter(row=>row.querySelector('input').checked);}
  update(){
    const rows=this.rows();
    const sum=rows.reduce((total,row)=>total+Number(row.querySelector('select').selectedOptions[0]?.dataset.price||0),0);
    const percent=rows.length>=3?10:rows.length>=2?5:0;
    const total=rows.reduce((amount,row)=>{const price=Number(row.querySelector('select').selectedOptions[0]?.dataset.price||0);return amount+price-Math.floor(price*percent/100);},0);
    this.querySelector('[data-bundle-total]').textContent=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(total/100);
    const saving=this.querySelector('[data-bundle-saving]');
    saving.hidden=percent===0||sum===0;
    saving.textContent=this.dataset.saving.replace('[percent]',String(percent));
    for(const row of this.querySelectorAll('[data-bundle-row]'))row.querySelector('select').disabled=!row.querySelector('input').checked;
  }
  async submit(event){
    event.preventDefault();
    if(this.busy)return;
    const items=this.rows().map(row=>({id:row.querySelector('select').value,quantity:1}));
    if(items.some(item=>!item.id))return;
    this.busy=true;
    const button=this.querySelector('button[type=submit]');
    const label=button.textContent;
    const error=this.querySelector('[data-bundle-error]');
    button.disabled=true;button.textContent=this.dataset.loading;error.hidden=true;
    try{
      const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);
      window.location.assign(this.dataset.cartUrl);
    }catch(cause){
      error.textContent=cause.message===this.dataset.error||cause.message?.length>20?cause.message:this.dataset.error;
      error.hidden=false;button.disabled=false;button.textContent=label;this.busy=false;
    }
  }
}
customElements.define('vm-bundle',VmBundle);
}
  } catch(e) { console.error(e); }
})();

})();
